import { useTranslation } from 'react-i18next';
import { PageSubtitle } from '@components/ui/PageFrame/PageFrame';
import styles from './styles.module.css';

/**
 * The security page for a company-account (SSO) session: there is no d-orca
 * password and no d-orca two-step verification — the company's sign-in owns
 * both — so the page says so instead of offering a manager that would fail.
 */
export function SsoManagedNotice() {
  const { t } = useTranslation();
  return (
    <div className={styles.page}>
      <PageSubtitle>{t('auth.mfa.settings.ssoSubtitle')}</PageSubtitle>
      <section className={styles.card}>
        <p className={styles.cardBody}>{t('auth.mfa.settings.ssoManaged')}</p>
      </section>
    </div>
  );
}
